export class PageView {
    constructor(eventEmitter) {
        this.eventEmitter = eventEmitter;
        this.gallery = document.querySelector('.gallery');
        const basketButton = document.querySelector('.header__basket');
        this.basketCounter = basketButton.querySelector('.header__basket-counter');
        basketButton.addEventListener('click', () => {
            this.eventEmitter.emit('cart:open');
        });
        this.updateBasketCounter(0);
    }
    // Добавляем отсутствующий метод
    renderGallery(items) {
        this.gallery.replaceChildren(...items);
    }
    updateBasketCounter(count) {
        this.basketCounter.textContent = count.toString();
        this.basketCounter.style.display = count > 0 ? 'flex' : 'none';
    }
}
